<template>
  <!-- 添加/编辑秒杀活动物品 -->
  <div>
    <!-- 添加弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="dialogType === 1 ? '添加秒杀' : '编辑秒杀'"
      width="350px"
      @close="closeDialog"
    >
      <el-form
        :model="formData"
        v-if="formData"
        ref="formData"
        label-width="80px"
        size="small"
        :rules="taskRules"
      >
        <el-form-item prop="prize_id" label="奖品">
          <div v-if="selectedPrize" class="prize-item" @click="visiblePrize = true">
            <img :src="selectedPrize.image" alt />
            <p>
              <span>{{ selectedPrize.name }}</span>
            </p>
            <p>
              <span>{{ selectedPrize.second_name }}</span>
            </p>
            <p>
              <span :style="`color: ${getRankColor(selectedPrize.rank)};`">{{
                getRank(selectedPrize.rank)
              }}</span>
              <span class="price">${{ selectedPrize.price }}</span>
            </p>
          </div>
          <div v-else class="add-prize" @click="visiblePrize = true">
            <i class="el-icon-plus"></i>
            <p>选择奖品</p>
          </div>
        </el-form-item>
        <el-form-item prop="tick_num" label="消耗秒杀卷数量">
          <el-input
            v-model="formData.tick_num"
            placeholder="请输入秒杀卷数量"
          ></el-input>
        </el-form-item>
        <el-form-item prop="prize_num" label="物品数量">
          <el-input
            v-model="formData.prize_num"
            placeholder="请输入物品数量"
          ></el-input>
        </el-form-item>
        <el-form-item prop="start_time" label="开始时间">
          <el-date-picker
            v-model="formData.start_time"
            type="datetime"
            placeholder="开始时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="end_time" label="结束时间">
          <el-date-picker
            v-model="formData.end_time"
            type="datetime"
            placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 奖品列表 -->
    <el-dialog
      :visible.sync="visiblePrize"
      title="奖品列表"
      :close-on-click-modal="false"
      width="930px"
    >
      <el-row style="margin-bottom: 20px">
        <el-input
          style="width: 200px; margin-right: 20px"
          placeholder="奖品名称搜索"
          v-model="query.name"
        ></el-input>
        <el-button type="primary" @click="getPrize">搜索</el-button>
      </el-row>
      <div class="prize-list-wrap" v-loading="loadingPrize">
        <ul class="prize-list">
          <li class="prize-item" v-for="item in prizeList" :key="item.id">
            <i
              class="el-icon-plus"
              title="添加"
              @click="handleAddPrize(item)"
            ></i>
            <img :src="item.image" alt />
            <p>
              <span>{{ item.name }}</span>
            </p>
            <p>
              <span>{{ item.second_name }}</span>
            </p>
            <p>
              <span v-if="item.darkgoldenrod === 1">暗金：普通"</span>
              <span v-if="item.darkgoldenrod === 2">暗金：StatTrak™"</span>
              <span v-if="item.darkgoldenrod === 3">暗金：★StatTrak™"</span>
              <span v-if="item.darkgoldenrod === 4">暗金：★"</span>
              <span v-if="item.darkgoldenrod === 5">暗金：纪念品"</span>
            </p>
            <p>
              <span :style="`color: ${getRankColor(item.rank)};`">{{
                getRank(item.rank)
              }}</span>
              <span class="price">${{ item.price }}</span>
            </p>
            <p style="text-align: center">
              数量：{{ item.number - item.sold_number }}
            </p>
          </li>
        </ul>
      </div>
      <el-pagination
        background
        :page-size="prizeListMeta.per_page || 15"
        :total="prizeListMeta.total || 0"
        :current-page="prizeListMeta.current_page"
        @current-change="handlePrizePageChange"
        v-if="prizeListMeta && prizeListMeta.total > prizeListMeta.per_page"
      ></el-pagination>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { getData, delApiData, getApiData, postApiData, patchApiData } from '../../http'
import rank from '../../utils/ranks'
import quality from '../../utils/quality'

export default {
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
    typeNum: {//弹窗类型
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      visiblePrize: false,//奖品列表显示标志
      loading: false,//加载动画
      loadingPrize: false,//加载物品列表的动画
      buttonLoading: false,//按钮加载动画
      taskData: undefined,//任务列表
      formData: {//任务表单
        prize_id: undefined,//选择的物品的id
        tick_num:undefined,//消耗秒杀卷数量
        prize_num: 1,//物品数量
        start_time: undefined,//开始时间
        end_time: undefined,//结束时间
      },
      prizeList:undefined,//奖品列表
      query:{//奖品搜索
        page:1,
        name:undefined,
      },
      selectedPrize: undefined,//选择的奖品信息
      prizeListMeta: undefined,//奖品列表的底部分页
      staticData:{
        rank:rank,
        quality:quality,
      },
      taskRules: {//任务表单验证
        prize_id: [
          {
            required: true,
            message: '请选择物品',
            trigger: 'blur'
          }
        ],
        tick_num: [
          {
            required: true,
            message: '请输入消耗秒杀卷数量',
            trigger: 'blur'
          }
        ],
      }
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    dialogInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
    dialogType: {
      get() {
        return this.typeNum
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      //监听添加或编辑弹窗显示
      if (val && this.dialogInfo) {
        this.formData = this.dialogInfo
      }
    },
    visiblePrize(val){
      //监听物品列表弹窗显示
      if(val){
        this.getPrize()
      }
    }
  },
  created() {
  },
  methods: {
    submit() {
      //保存
      //表单验证后发起请求
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          this.buttonLoading = true
          let params = this.formData

          if (this.dialogType == 1) {
            postApiData('secondKill', params).then(res => {
              this.$message.success('添加成功！')
              this.closeDialog()//关闭弹窗
              this.$emit("refresh")//刷新数据
            }).finally(() => {
              this.buttonLoading = false
            })
          } else if (this.dialogType == 2) {
            patchApiData(`secondKill`, params).then(res => {
              this.$message.success('编辑成功！')
              this.closeDialog()//关闭弹窗
              this.$emit("refresh")//刷新数据
            }).finally(() => {
              this.buttonLoading = false
            })
          }
        }
      })
    },
    handleEdit(row) {
      //编辑奖品前赋值
      this.selectedPrize = row
      this.formData.prize_id = row.id
    },
    handleAddPrize(row) {
      //选择奖品并赋值
      this.formData.prize_id = row.id
      this.selectedPrize = row
      this.visiblePrize = false
    },
    getPrize() {
      //查询奖品
      this.loadingPrize = true
      let params=this.query
      getData(`prize`, params)
        .then(res => {
          this.prizeList = res.data
          this.prizeListMeta = res
        })
        .finally(() => {
          this.loadingPrize = false
        })
    },
    handlePrizePageChange(page) {
      //奖品列表点击底部分页
      this.query.page = page
      this.getPrize()
    },
    getRank(rank) {
      for (let item of this.staticData.rank) {
        if (item.level === rank) {
          return item.text
        }
      }
    },
    getRankColor(rank) {
      for (let item of this.staticData.rank) {
        if (item.level === rank) {
          return item.color
        }
      }
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
</style>